import { Heading4Props } from "./types"
import React from "react"
import { HeadingCore } from "./core"

const Heading4: React.FC<Heading4Props> = (props) => {
  return <HeadingCore {...props} fontSize={"xl"} />
}

export default Heading4
